import { cva } from '@/styled-system/css';

export const bannerIconRecipe = cva({
  base: {},
  variants: {
    tone: {
      critical: { color: 'Banner.critical.icon' },
      info: { color: 'Banner.info.icon' },
      success: { color: 'Banner.success.icon' },
      warning: { color: 'Banner.warning.icon' },
    },
  },
});
